import { render } from "./IntegrationOrdersTable.vue?vue&type=template&id=5cca613f"
import script from "./IntegrationOrdersTable.vue?vue&type=script&lang=js"
export * from "./IntegrationOrdersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__